import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Link, useLocation } from 'react-router-dom';
import { ReactComponent as Graphic } from './graphic.svg';
import { ReactComponent as Column } from './column.svg';
import Home from './components/Home';
import Login from './components/Login';
import EventPage from './components/EventPage';
import Seo from './components/Seo';
import { SITE_NAME, SITE_URL } from './seo';

function NotFound() {
  return (
    <div className="p-10">
      <Seo
        title={`Page not found | ${SITE_NAME}`}
        description="This page could not be found."
        canonicalUrl={`${SITE_URL}${window.location.pathname}`}
        robots="noindex, nofollow"
      />
      Page not found
    </div>
  );
}

function Layout() {
  const location = useLocation();
  const notHome = location.pathname !== '/';

  useEffect(() => {
    const targetPosition =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 3000;
    let startTime = null;
    function easeInOutCubic(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t * t + b;
      t -= 2;
      return (c / 2) * (t * t * t + 2) + b;
    }
    function animateScroll(currentTime) {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const run = easeInOutCubic(timeElapsed, startPosition, distance, duration);
      window.scrollTo(0, run);
      if (timeElapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    }
    requestAnimationFrame(animateScroll);
  }, []);

  return (
    <div className="min-h-screen mx-5 md:mx-[10vw] relative">
      {!notHome && (
        <header className="sticky top-0 w-full z-10 pointer-events-none">
          <Link to="/">
            <Graphic className="w-full h-auto" />
          </Link>
        </header>
      )}
      {notHome && (
        <Link to="/" className="fixed top-4 left-4 z-10">
          <Column className="w-20 h-auto" />
        </Link>
      )}
      <main className={notHome ? 'pt-10' : 'pt-[16%]'}>
        <Outlet />
      </main>
      <footer className="fixed bottom-0 left-0 w-full p-5 text-sm flex flex-col items-center gap-2 md:flex-row md:justify-between">
        <a href="https://instagram.com/mezzanine_studios/" target="_blank" rel="noreferrer" className='inline'>
            <img src="/ig.png" className="w-8 h-8" alt="Instagram" />
        </a>
        <span className='text-center md:text-left'>Unit 15 Orion Business Centre, SE14 5RT London</span>
        <span className='text-center'>contact.mezzaninestudio@gmail.com</span>
        <span className='text-center md:text-right'>© {new Date().getFullYear()} MEZZANINE CIC</span>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}> 
          <Route
            index
            element={
              <>
                <div className="md:mx-[25%] text-left text-[4vw] md:text-[1.8vw] leading-relaxed mb-20">
                  MEZZANINE is an artist-run non-profit art space located in the Bermondsey Triangle.
                  Established as a Community Interest Company in September 2024, MEZZANINE was founded
                  to support artists through the provision of affordable studio, exhibition, and event spaces.
                  With eight enclosed multi-occupant studios, a shared multipurpose workspace, a music studio,
                  and newly renovated gallery, we provide a much-needed space for artists to develop and showcase
                  a diverse range of creative practices.
                </div>
                <Home />
              </>
            }
          />
          <Route path="events/:slug" element={<EventPage />} />
          <Route path="login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
